import { Component } from '@theme/component';

class TypewriterComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#init();
  }

  #tick() {
    let i = this.loopNum % this.toRotate.length;
    let fullTxt = this.toRotate[i];

    if (this.isDeleting) {
      this.txt = fullTxt.substring(0, this.txt.length - 1);
    } else {
      this.txt = fullTxt.substring(0, this.txt.length + 1);
    }

    this.innerHTML = this.txt;

    let delta = 200 - Math.random() * 100;

    if (this.isDeleting) {
      delta /= 2;
    }

    if (!this.isDeleting && this.txt === fullTxt) {
      delta = this.period;
      this.isDeleting = true;
    } else if (this.isDeleting && this.txt === '') {
      this.isDeleting = false;
      this.loopNum++;
      delta = 500;
    }

    setTimeout(() => {
      this.#tick();
    }, delta);
  }

  #init() {
    let toRotate = this.getAttribute('data-type');
    if (toRotate) {
      this.toRotate = JSON.parse(toRotate);
      this.loopNum = 0;
      this.period = parseInt(this.getAttribute('data-period') || '2000', 10);
      this.txt = '';
      this.#tick();
      this.isDeleting = false;
    }
  }
}

if (!customElements.get('typewriter-component')) {
  customElements.define('typewriter-component', TypewriterComponent);
}
